export const POINT_SNAPPING_CONFIGURATION = {
  // This will be adjusted by the camera's anti-zoom factor. This value was chosen because it is slightly larger than
  //   the cursor when picking points.
  SnappingThreshold: 2,

  GridSize: 1 / 16,
};
